import React from 'react';
import { Keyword } from '../../types';
import { KeywordBadge } from '../ui/KeywordBadge';

export interface KeywordsPanelProps {
  /** List of keywords to display */
  keywords: Keyword[];
  /** Optional className for additional styling */
  className?: string;
}

/**
 * KeywordsPanel Component
 * 
 * Displays all character keywords with tooltips using the existing KeywordBadge component.
 * Styled to match the codex detail page aesthetic.
 * 
 * Requirements: 3.6
 */
export const KeywordsPanel: React.FC<KeywordsPanelProps> = ({
  keywords,
  className = '',
}) => {
  if (!keywords || keywords.length === 0) {
    return null;
  }

  return (
    <div className={`keywords-panel ${className}`} data-testid="keywords-panel">
      <div className="keywords-grid flex flex-wrap gap-2" data-testid="keywords-list">
        {keywords.map((keyword, index) => (
          <div
            key={`${keyword.name}-${index}`}
            className="keyword-badge"
            data-testid={`keyword-${index}`}
          >
            <KeywordBadge
              keyword={keyword.name}
              value={keyword.value}
              showTooltip={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
